import { render, staticRenderFns } from "./ActioncamDetailConfiguration.vue?vue&type=template&id=51e15597&"
import script from "./ActioncamDetailConfiguration.vue?vue&type=script&lang=js&"
export * from "./ActioncamDetailConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports